(function () {
  if (window.fhPrintShowcaseInit) return;
  window.fhPrintShowcaseInit = true;

  function closeAll(except) {
    document.querySelectorAll('.fh-ps-spot.is-open').forEach(function (spot) {
      if (spot === except) return;
      spot.classList.remove('is-open');
      spot.querySelector('.fh-ps-dot').setAttribute('aria-expanded', 'false');
      spot.querySelector('.fh-ps-tip').hidden = true;
    });
  }

  function highlight(card, index, on) {
    var spot = card.querySelector('.fh-ps-spot[data-index="' + index + '"]');
    if (spot) spot.classList.toggle('is-hl', on);
  }

  function openDialog(root, card) {
    var dialog = root.querySelector('.fh-ps-dialog');
    var body = dialog.querySelector('.fh-ps-dialog__body');
    var clone = card.cloneNode(true);
    clone.removeAttribute('id');
    // tip ids must stay unique while the clone is open
    clone.querySelectorAll('[id]').forEach(function (el) {
      var newId = el.id + '-lg';
      var ctrl = clone.querySelector('[aria-controls="' + el.id + '"]');
      if (ctrl) ctrl.setAttribute('aria-controls', newId);
      el.id = newId;
    });
    var img = clone.querySelector('.fh-ps-img');
    if (img) { img.setAttribute('sizes', '92vw'); img.loading = 'eager'; }
    body.innerHTML = '';
    body.appendChild(clone);
    dialog.showModal();
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.fh-ps-dot');
    if (dot) {
      var spot = dot.closest('.fh-ps-spot');
      var open = !spot.classList.contains('is-open');
      closeAll(spot);
      spot.classList.toggle('is-open', open);
      dot.setAttribute('aria-expanded', String(open));
      spot.querySelector('.fh-ps-tip').hidden = !open;
      return;
    }

    var toggle = e.target.closest('.fh-ps-toggle');
    if (toggle) {
      var card = toggle.closest('.fh-ps-card');
      var off = !card.classList.contains('fh-ps-dots-off');
      if (off) closeAll();
      card.classList.toggle('fh-ps-dots-off', off);
      toggle.setAttribute('aria-pressed', String(off));
      toggle.querySelector('.fh-ps-toggle__text').textContent = off ? 'Show dots' : 'Hide dots';
      return;
    }

    var root = e.target.closest('[data-fh-print-showcase]');
    if (!root) { closeAll(); return; }

    if (e.target.closest('.fh-ps-dialog__close')) {
      e.target.closest('.fh-ps-dialog').close();
      return;
    }
    if (e.target.classList.contains('fh-ps-dialog')) { // backdrop click
      e.target.close();
      return;
    }

    var inDialog = e.target.closest('.fh-ps-dialog');
    if (!inDialog && (e.target.closest('.fh-ps-expand') || e.target.classList.contains('fh-ps-img'))) {
      closeAll();
      openDialog(root, e.target.closest('.fh-ps-card'));
      return;
    }

    if (!e.target.closest('.fh-ps-tip')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  ['mouseover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var item = e.target.closest && e.target.closest('.fh-ps-legend__item[data-index]');
      if (item) highlight(item.closest('.fh-ps-card'), item.dataset.index, true);
    });
  });
  ['mouseout', 'focusout'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var item = e.target.closest && e.target.closest('.fh-ps-legend__item[data-index]');
      if (item && !item.contains(e.relatedTarget)) highlight(item.closest('.fh-ps-card'), item.dataset.index, false);
    });
  });
})();
